<template>
  <td class="app-menu-configuracoes">
    <!-- SETA A LOGOTIPO DA LICENÇA DE USO -->
    <div class="botao" ref="divBotao" @click="appMenuConfiguracaoOnMostrarOcultar">
      <i class="fa fa-cog" aria-hidden="true"></i>
    </div>

    <!-- BOTÃO PARA DOCUMENTAÇÃO -->
    <a class="botao ajuda" title="Clique aqui para abrir a documentação do Rotina Fácil." target="_blank" :href="documentacao">
      <i class="fa fa-question" aria-hidden="true"></i>
    </a>

    <!-- SETA O CONTEUDO DA TELA -->
    <RF-Dialog-Referencia :cpntPositionFixed="true" v-if="mostrar === true" :cpntElement="$refs.divBotao" :cpntOnFechar="appMenuConfiguracaoOnMostrarOcultar" :cpntAlignX="'bottom'">
      <div class="app-menu-configuracoes-opcoes">
        <template v-for="(button, index) in opcoes">
          <router-link v-if="button.link !== undefined" tag='a' :to='button.link' :href='button.link' :key="'link-' + index" :target="button.target">
            <div @click="appMenuConfiguracoesAtualizaConteudo(button.link)">
              <i :class="button.icone" aria-hidden="true"></i>
              <span v-html="button.nome"></span>
            </div>
          </router-link>

          <a :key="'click-' + index" v-else @click="button.onClick">
            <div @click="appMenuConfiguracoesAtualizaConteudo(button.link)">
              <i :class="button.icone" aria-hidden="true"></i>
              <span v-html="button.nome"></span>
            </div>
          </a>
        </template>
      </div>
    </RF-Dialog-Referencia>
  </td>
</template>

<style scoped>
.app-menu-configuracoes {
  text-align: center;
  padding: 0px 5px;
}
.app-menu-configuracoes > .botao {
  cursor: pointer;
  width: 25px;
  text-align: center;
  display: inline-block;
  color: #fff;
}
  .app-menu-configuracoes > .botao > svg {
    font-size: 20px;
  }
  .app-menu-configuracoes > .ajuda {
    width: 20px;
  }
  .app-menu-configuracoes > .ajuda > svg {
    font-size: 15px;
    vertical-align: initial !important;
  }

.app-menu-configuracoes-opcoes {
  width: 250px;
}
.app-menu-configuracoes-opcoes > a {
  width: 100%;
  display: block;
  text-decoration: none;
  color: #222;
  font-size: var(--font-base-soma-15);
  font-weight: 400;
  cursor: pointer;
}
  .app-menu-configuracoes-opcoes > a > div {
    padding: 8px 15px;
    text-align: left;
  }
  .app-menu-configuracoes-opcoes > a > div:hover {
    color: #fff;
    background-color: #219dab;
    border-radius: 4px;
  }
    .app-menu-configuracoes-opcoes > a > div > svg {
      margin-right: 10px;
      font-size: var(--font-base-soma-18);
      width: 25px;
    }
</style>

<style>
</style>

<script>
  export default {
    components: {
      'RF-Dialog-Referencia': () => import('@/components/rf-geral/dialog/RF-Dialog-Referencia.vue')
    },
    data: function () {
      return {
        mostrar: false,
        requestId: '',
        requestTp: '',
        opcoes: [],
        documentacao: process.env.VUE_APP_URL_WEB + '/documentacao'
      }
    },
    methods: {
      appMenuConfiguracaoMostrarDados: function () {
        // SETA SE DEVE OU NÃO MOSTRAR O REGISTRO
        this.mostrar = !this.mostrar

        // // CHAMA A FUNÇÃO PARA SETAR OS BOTOES
        if (this.mostrar === true) {
          this.appMenuConfiguracoesSetarOpcoes()
        }
      },
      appMenuConfiguracaoOnMostrarOcultar: function (event, requestId = '') {
        if (requestId === '' || requestId === this.requestId) {
          // PEGA O TIPO DO EVENTO SOLICITADO
          var tipo = event.type

          // SETA O REQUEST DA REQUISIÇÃO
          requestId = (Math.floor(Math.random() * (9999 - 1000)) + 1000)
          
          // SETA O REQUESTID ATUALIZADO
          this.requestId = requestId

          // VERIFICA SE DEVE MOSTRAR OU NÃO
          if (tipo === 'click' && this.mostrar === false) {
            // MOSTRA O MENU SOLICITADO
            this.mostrar = true
            
            // SETA O TIPO DESEJADO
            this.requestTp = tipo

            // CHAMA A FUNÇÃO PARA SETAR OS BOTOES
            this.appMenuConfiguracoesSetarOpcoes()
          } else if (tipo === 'click' && this.mostrar === true && this.requestTp !== 'click') {
            // MOSTRA O MENU SOLICITADO
            this.mostrar = true
            
            // SETA O TIPO DESEJADO
            this.requestTp = tipo

            // CHAMA A FUNÇÃO PARA SETAR OS BOTOES
            this.appMenuConfiguracoesSetarOpcoes()
          } else if (tipo === 'click' && this.mostrar === true && this.requestTp === 'click') {
            this.appMenuConfiguracaoFechar(null, requestId, true)
          } else if (this.requestTp !== 'click' && (tipo === 'mouseenter' && this.mostrar === false)) {
            // MOSTRA O MENU SOLICITADO
            this.mostrar = true
            
            // SETA O TIPO DESEJADO
            this.requestTp = tipo

            // CHAMA A FUNÇÃO PARA SETAR OS BOTOES
            this.appMenuConfiguracoesSetarOpcoes()
          } else if (this.requestTp !== 'click' && (tipo === 'mouseleave' && this.mostrar === true)) {
            this.appMenuConfiguracaoFechar(null, requestId)
          }
        }
      },
      appMenuConfiguracaoFechar: function (callback = null, requestId = '', forcar = false) {
        // AGUARDA UNS MS PARA FECHAR O MENU
        setTimeout(() => {
          if (forcar === true || requestId === this.requestId) {
            // MOSTRA O MENU SOLICITADO
            this.mostrar = false
            
            // SETA O TIPO DESEJADO
            this.requestTp = ''

            // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          }
        }, forcar === true ? 0 : 250)
      },
      appMenuConfiguracoesSetarOpcoes: function () {
        // LIMPA TODOS OS BOTÕES DISPONIVEIS
        this.opcoes = []

        // ADICIONA O BOTÃO MEU CADASTRO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 720, 710, 68 ], 'or', false) === true) {
          this.opcoes.push({ icone: 'far fa-id-card', nome: 'Meu Cadastro', target: '_parent', link: this.$router.resolve({ name: 'config_cadastro', params: { cts: this.$store.state.token.cts } }).href })
        }

        // ADICIONA O BOTÃO MEU USUARIO
        this.opcoes.push({ icone: 'fa fa-user fa-fw', nome: 'Meu Usuário', target: '_parent', link: ('/' + this.$store.state.token.cts + '/cs/' + window.btoa(JSON.stringify({ url: (process.env.VUE_APP_URL_CS + '/app/usuarios/usu_ger.php?cts=' + this.$store.state.token.cts), post: {}, target: '_this' }))) })

        // ADICIONA O BOTÃO MEU PAGAMENTOS
        if (this.$store.state.token.dep_plus === false && this.$store.state.token.clu_con === 'l' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 559 ], null, false) === true) {
          this.opcoes.push({ icone: 'fas fa-money-bill', nome: 'Meus Pagamentos', target: '_parent', link: this.$router.resolve({ name: 'pagamentos', params: { cts: this.$store.state.token.cts } }).href })
        }

        // ADICIONA O BOTÃO PARA CONFIGURAÇÃO DA INTEGRAÇÃO
        if (this.$store.state.token.ect === true && this.$store.state.token.usuario === 'SuporteRF') {
          this.opcoes.push({ icone: 'fas fa-plug', nome: 'Config. Integração', target: '_parent', link: this.$router.resolve({ name: 'conector_config', params: { cts: this.$store.state.token.cts } }).href })
        }

        // ADICIONA O BOTÃO GERENCIAR USUARIOS
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 1 ], null, false) === true) {
          this.opcoes.push({ icone: 'fa fa-users', nome: 'Gerenciar Usuários', target: '_parent', link: ('/' + this.$store.state.token.cts + '/cs/' + window.btoa(JSON.stringify({ url: process.env.VUE_APP_URL_CS + '/app/usuarios/usuarios.php?cts=' + this.$store.state.token.cts, post: {}, target: '_this', menu: true }))) })
        }

        // ADICIONA O BOTÃO CONTA DE E-MAIL
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 3 ], null, false) === true) {
          this.opcoes.push({ icone: 'fa fa-at', nome: 'Contas de E-mail', target: '_parent', link: ('/' + this.$store.state.token.cts + '/cs/' + window.btoa(JSON.stringify({ url: process.env.VUE_APP_URL_CS + '/app/configuracoes/usu_email.php?cts=' + this.$store.state.token.cts, post: {}, target: '_this', menu: true }))) })
        }

        // ADICIONA O BOTÃO CONTADOR
        // if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 25, 23, 31 ], 'or', null, null, null, null, false) === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 34 ], null, null, null, null, null, false) === false && (this.$store.state.token.clu_mu === 'a' || this.$store.state.token.clu_pu === 'a')) {
        // 28/10/2021 - 14:44 RAPHAEL PEDIU PARA REMOVER A VALIDAÇÃO DA PARTE FISCAL, PARA QUE SEJA POSSIVEL GERENCIAR OUTRAS LICENÇAS QUE NÃO TEM DOCUMENTO FISCAL COMO EXEMPLO DA CLIENTE IRMÃ HELENIR CLU 3121 
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 34 ], null, null, null, null, null, false) === false && (this.$store.state.token.clu_mu === 'a' || this.$store.state.token.clu_pu === 'a')) {
          this.opcoes.push({ icone: 'fas fa-user-tie', nome: 'Contador', target: '_parent', link: this.$router.resolve({ name: 'config_contador', params: { cts: this.$store.state.token.cts } }).href })
        }

        // ADICIONA O BOTÃO LOG DE ACESSO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 1 ], null, [ 3 ], null, [ 2 ], null, false) === true) {
          this.opcoes.push({ icone: 'fa fa-list-alt', nome: 'Logs de Acesso', target: '_parent', link: ('/' + this.$store.state.token.cts + '/cs/' + window.btoa(JSON.stringify({ url: process.env.VUE_APP_URL_CS + '/app/usuarios/usu_log_ace.php?cts=' + this.$store.state.token.cts, post: {}, target: '_this', menu: true }))) })
        }
        // <font-awesome-icon icon="far fa-file-code" />

        // IMPORTAR XML
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5, 21 ], 'or', [ 11, 2 ], 'or', null, null, false) === true) {
          this.opcoes.push({ icone: 'far fa-file-code', nome: 'Importar XML', target: '_parent', link: this.$router.resolve({ name: 'config_importar_xml', params: { cts: this.$store.state.token.cts } }).href })
        }

        // ADICIONA O BOTÃO SUPORTE
        this.opcoes.push({ icone: 'fa fa-life-ring', nome: 'Suporte', target: '_parent', link: ('/' + this.$store.state.token.cts + '/cs/' + window.btoa(JSON.stringify({ url: process.env.VUE_APP_URL_CS + '/app/suporte/suporte.php?cts=' + this.$store.state.token.cts, post: {}, target: '_this', menu: true }))) })

        // ADICIONA O BOTÃO SUPORTE
        this.opcoes.push({ icone: 'fas fa-headset', nome: 'Acesso Remoto [ALT+S]', onClick: () => {
          // MANDA ABRIR A TELA
          this.$store.commit('EXECUTE_ATALHO', 'ALT+S')

          // MANDA FECHAR O MENU DE OPÇOES
          this.appMenuConfiguracaoFechar(null, this.requestId, true)
        } })
      },
      appMenuConfiguracoesAtualizaConteudo: function (rota) {
        // SETA O FLAG PARA ATUALIZAR O COMPONENT
        this.$store.commit('SET_TIME_CONTEUDO', this.$router.resolve(rota))

        // FORÇA O FECHAMENTO DA OPÇÃO
        this.appMenuConfiguracaoFechar(null, this.requestId, true)

        // ABRE O CHAT, SE ELE ESTIVER FECHADO
        if (rota.indexOf('/reg-atendimentos') === -1 && [ '', null, undefined ].indexOf(this.$store.state.atalhos['ALT+A']) === -1 && this.$store.state.atalhos['ALT+A'].mostrar === true) {
          this.$store.commit('EXECUTE_ATALHO', 'ALT+A')
        }
      }
    }
  }
</script>
